import { IMockedPlayer } from './player/player';

const players_cards = [
  {
    type: '2.H',
    order: 2,
  },
  {
    type: '2.H',
    order: 2,
  },
  // {
  //   type: '2.H',
  //   order: 3,
  // },
  {
    type: '5.C',
    order: 4,
  },
];

const cards = [
  {
    type: '2.H',
    order: 2,
  },
  {
    type: '5.C',
    order: 3,
  },
  {
    type: '5.C',
    order: 4,
  },
];

const status = 'not_ready';

const tickets = [{ roll: 1 }];

const FAKE_DATA: IMockedPlayer[] = [
  {
    cards: players_cards,
    ready_to_play: true,
    status,
    tickets,
    user: {
      avatar_url: 'https://placekitten.com/150',
      username: 'Player 1',
      id: '1',
    },
    winner: false,
  },

  {
    cards: players_cards,
    ready_to_play: false,
    status,
    tickets,
    user: {
      avatar_url: 'https://placekitten.com/150',
      username: 'Player 2',
      id: '2',
    },
    winner: false,
  },

  {
    cards: players_cards,
    ready_to_play: false,
    status,
    tickets,
    user: {
      avatar_url: 'https://placekitten.com/150',
      username: 'Player 3',
      id: '3',
    },
    winner: false,
  },

  {
    cards,
    ready_to_play: true,
    status,
    tickets,
    user: {
      avatar_url: 'https://placekitten.com/150',
      username: 'Lalo Salamanca',
      id: '624de9d937daf5b1fa8abc7e',
    },
    winner: true,
  },

  {
    cards: players_cards,
    ready_to_play: true,
    status,
    tickets,
    user: {
      avatar_url: 'https://placekitten.com/150',
      username: 'Player 4',
      id: '4',
    },
    winner: false,
  },

  // {
  //   cards: players_cards,
  //   ready_to_play: false,
  //   status,
  //   tickets,
  //   user: {
  //     avatar_url: 'https://placekitten.com/150',
  //     username: 'Player 5',
  //     id: '5',
  //   },
  //   winner: false,
  // },

  // {
  //   cards: players_cards,
  //   ready_to_play: true,
  //   status,
  //   tickets,
  //   user: {
  //     avatar_url: 'https://placekitten.com/150',
  //     username: 'Player 6',
  //     id: '6',
  //   },
  //   winner: false,
  // },
];

export default FAKE_DATA;
